import { useTranslation } from 'react-i18next'
import type { Rally, RallyDay } from '../../data/rallies'
import CityOG from './CityOG'

// Schedule by date for any rally in data/rallies.ts. Same markup as Cities.tsx.
export function RallyCities({ rally }: { rally: Rally }) {
  const { t } = useTranslation()
  // one grid cell per day, except days marked stackWithPrevious, which share the previous day's cell
  const cells = rally.days.reduce<RallyDay[][]>((acc, day) => {
    if (day.stackWithPrevious && acc.length) acc[acc.length - 1].push(day)
    else acc.push([day])
    return acc
  }, [])
  const cols = cells.length > 1 ? 'md:grid-cols-2' : ''
  return (
    <div className={`py-10 w-full grid grid-cols-1 ${cols} gap-10 gap-y-20 justify-center mb-10`}>
      {cells.map((days) => (
        <div key={`${days[0].monthKey}-${days[0].dayKey}`} className='flex flex-col items-center gap-20'>
          {days.map((day) => (
            <div key={`${day.monthKey}-${day.dayKey}`} className='flex flex-col items-center gap-8'>
              <h3 className='text-4xl md:text-5xl font-medium underline'>
                {t(`home.${day.dayKey}`)} {t(day.monthKey)}
              </h3>
              <ul className='space-y-4 opacity-90 text-center text-2xl'>
                {day.cities.map((city) => (
                  <CityOG key={city} city={city} rally={rally} />
                ))}
              </ul>
            </div>
          ))}
        </div>
      ))}
    </div>
  )
}
